import React, { useEffect, useMemo } from "react";
import { PropertyOption } from "./Step3.types";
import DebounceInput from "PhishingManager/components/DebouncedInput";
import SelectedLabel from "./SelectedLabel";
import InfinityScrollWrapper from "Components/InfinityScroll/InfinityScrollWrapper";
import RecipientItem from "../CampaignSteps/components/RecipientItem";

interface Props {
  propertyOptions: PropertyOption[];
  selectedProperties: number[];
  totalProperties: number;
  moveCurrentPage: () => void;
  setSelectedProperties: (propertyIds: number[]) => void;
  setPropertySearchQuery: (value: string) => void;
  setSelectedUserCount: (value: number) => void;
}

const PropertyRecipients: React.FC<Props> = ({
  propertyOptions,
  selectedProperties,
  totalProperties,
  moveCurrentPage,
  setSelectedProperties,
  setPropertySearchQuery,
  setSelectedUserCount
}) => {
  const allSelected = propertyOptions.length > 0 && selectedProperties.length === propertyOptions.length;

  const handleSelectAll = () => {
    if (allSelected) setSelectedProperties([]);
    else setSelectedProperties(propertyOptions.map((p) => p.value));
  };

  const handleToggle = (propertyId: number) => {
    if (selectedProperties.includes(propertyId)) setSelectedProperties(selectedProperties.filter((p) => p !== propertyId));
    else setSelectedProperties([...selectedProperties, propertyId]);
  };

  const totalCount = useMemo(() => {
    return propertyOptions.filter((p) => selectedProperties.includes(p.value)).reduce((acc, p) => acc + p.count, 0);
  }, [propertyOptions, selectedProperties]);

  useEffect(() => {
    setSelectedUserCount(totalCount);
  }, [totalCount])

  return (
    <div className="phishing-step3__property-section">
      <div className="phishing-step3__property-search">
        <DebounceInput placeholder="Search properties" setDebouncedSearch={setPropertySearchQuery} />
      </div>

      <SelectedLabel labelText={`Select properties (${propertyOptions.length})`} totalCount={totalCount} selectedAll={allSelected} handleSelectAll={handleSelectAll} />

      <div className="phishing-step3__role-list">
        {propertyOptions.length === 0 ? (
          <div className="phishing-step3__role-item phishing-step3__role-item--empty">
            No properties found.
          </div>
        ) : <InfinityScrollWrapper
          dataLength={propertyOptions.length}
          hasMore={propertyOptions.length < totalProperties}
          onLoadMore={moveCurrentPage}
          height={400}
          scrollableId="property-scroll-container"
          loaderText={'Loading more properties...'}
          endMessageText="">
          {propertyOptions.map((property) => (
            <RecipientItem
              key={property.value}
              title={property.label}
              description={`${property.count} user${property.count > 1 ? "s" : ""}`}
              iconType={"recipientProperty"}
              isChecked={selectedProperties.includes(property.value)}
              onToggle={() => handleToggle(property.value)}
            />
          ))}
        </InfinityScrollWrapper>}
      </div>
    </div>
  );
};

export default PropertyRecipients;